<template>
  <PageTitle pageTitle="Yetkisiz" subTitle="Diğer" />

  <NoAccess />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import NoAccess from "@/components/Modules/Errors/NoAccess/index.vue";

export default defineComponent({
  name: "NoAccessPage",
  components: {
    PageTitle,
    NoAccess,
  },
});
</script>
